import $ from 'jquery';
import IdleJs from 'idle-js';

require('slick-carousel');
require('./jquery.smoothState');

$(function() {

    'use strict';

    // When entering the page for the first time, remove local storage history
    // Won't be triggered when browsing around the website because those pages are loaded through SmoothState
    localStorage.removeItem('hodb_history');

    var options = {
        prefetch: true,
        cacheLength: 2,
        onStart: {
            duration: 250,
            render: function ($container) {
                // Save scroll position if applicable
                const fromIndexPage = $container[0].firstElementChild.classList.contains('remember-scroll');
                if (fromIndexPage) {
                    const scrollPosition = $(document).scrollTop();
                    localStorage.setItem('scrollPosition', scrollPosition);
                }

                if (!fromIndexPage) {
                    // Add exiting animation when leaving detail page
                    $('.exit-animation').addClass('is-exiting');
                }

                // Restart your animation
                smoothState.restartCSSAnimations();
            }
        },
        onReady: {
            duration: 0,
            render: function ($container, $newContent) {
                // Remove your CSS animation reversing class
                $('.exit-animation').removeClass('is-exiting');

                // Inject the new content
                $container.html($newContent);

                // Restore scroll position if applicable
                const toIndexPage = $newContent[0].classList.contains('remember-scroll');
                const scrollPosition = localStorage.getItem('scrollPosition');
                if (scrollPosition && toIndexPage) {
                    $(document).scrollTop(scrollPosition);
                }

                // Also hide navbar (doesn't need to be hidden if visitor enters site on the page)
                if (! toIndexPage) {
                    $('#workholder').addClass('idle');
                }

                // Make sure idle mode is turned off
                $('#workholder.gallery').removeClass('idle');

                // Don't trigger page load animation again
                $('.slideInUp').removeClass('slideInUp');

                initSlick();
                initHistory();
                initVideo();
                initIdle();
            }
        },
        blacklist: '.no-smoothState',
    },
    smoothState = $('#main').smoothState(options).data('smoothState');

    function initSlick() {
        // Init slick slider
        const slider = $('.slick').slick({
            autoplay: false,
            speed: 500,
        });

        // Bind thumbnail click
        $('.slick-toggle').click(function(e) {
            const index = $(e.target).data('number');
            slider.slick('slickGoTo', index);
        });

        // Bind custom arrows
        $('.arrow-prev').click(function() {
            slider.slick('slickPrev');
        });
        $('.arrow-next').click(function() {
            slider.slick('slickNext');
        });

        // Update download image for current image
        slider.on('afterChange', function() {
            const path = $('.slick-current img').attr('src');
            $('#downi').attr('href', path);
        });

        // Hide arrows if scrolled past top of page
        $('#workholder').scroll(function(e) {
            // $('.arrow').toggle(e.target.scrollTop < 10);
            if (e.target.scrollTop < 20) {
                $('.arrow').not(':visible').fadeIn();
            } else {
                $('.arrow').fadeOut();
            }
        });
    }

    initSlick();

    $('#yearnav li').click(function(e) {
        const year = $(e.target).data('year');
        const scrollTo = $('#main').find(`[data-year='${year}']`);
        $('html, body').animate({
            scrollTop: scrollTo.offset().top - 100
        }, 500);
    });

    function initHistory() {
        let history = localStorage.getItem('hodb_history') ? JSON.parse(localStorage.getItem('hodb_history')) : [];

        // Change back button target if history found in local storage
        if (history.length > 0) {
            $('#return').attr('href', history[history.length - 1]);
        }

        // Remove URL from history when clicked
        $('#return').click(function(e) {
            const href = $(e.target).attr('href');

            if (history[history.length - 1] === href) {
                history.pop();
                localStorage.setItem('hodb_history', JSON.stringify(history));
            }
        });

        // Save current before leaving it when clicking related item
        $('.save-history').click(function() {
            const path = window.location.href;
            let history = localStorage.getItem('hodb_history') ? JSON.parse(localStorage.getItem('hodb_history')) : [];
            history.push(path);
            localStorage.setItem('hodb_history', JSON.stringify(history));
        });
    }

    initHistory();

    function initVideo() {
        $('.play-video').click(function(e) {
            e.stopPropagation();
            $('#video-overlay').show();
            $('#video-overlay video').get(0).play();
            return;
        });

        $('#video-overlay').click(function() {
            $('#video-overlay').hide();
            $('#video-overlay video').get(0).pause();
            $('#video-overlay video').get(0).currentTime = 0;
        });

        $('video').click(function(e) {
            e.stopPropagation();
        });
    }

    initVideo();

    function initIdle() {
        var idle = new IdleJs({
            idle: 1500,
            events: ['scroll'],
            onIdle: function () {
                if ($('#workholder').scrollTop() < 100) {
                    $('#workholder.gallery').addClass('idle');
                }
            },
            onActive: function () {
                $('#workholder.gallery').removeClass('idle');
            },
        });
        idle.start();
    }

    initIdle();

});
